import { version } from '~/package.json'

export default defineAppConfig({
  appVersion: version,
  siteName: 'Die Leckorter',
  suiteBaseUrl: 'https://eu.1tool.cloud/',
  socketBaseUrl: 'wss://luisgomezdev.com',
  socketAccessToken: 'fpEnmgn9YkXke_cQNAgiCBsaJZH.cX@uw!teqhq8Ys7y9Xft927nykb!woaoG-qC',
  tenantId: '8b5d9bd6-e396-4539-9053-3fb59b2c7c01',
  routing: {
    startPage: 'events'
  },
  vendor: {
    vuelidate: {
      $lazy: true,
      $autoDirty: false
    },
    marked: { headerIds: false, mangle: false }
  },
  optimizeDeps: {
    include: ['esm-dep' > 'cjs-dep']
  },
  ui: {
    primary: 'customPrimary'
  }
})
